<script>
import Layout from '@layouts/loading.vue'
import * as animationData from '@/../public/assets/animations/loading_lines_circle.json'
import Lottie from '@/components/general/lottie.vue'

export default {
  name: 'LoadingView',
  metaInfo() {
    return {
      title: this.$t('loading.loadingPageTitle'),
      meta: [
        {
          name: 'description',
          content: this.$t('loading.loadingMetaDescription'),
        },
      ],
    }
  },
  components: {
    Layout,
    Lottie,
  },
  data() {
    return {
      defaultOptions: {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
      },
      animationSpeed: 1,
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
    },
  },
}
</script>

<template>
  <Layout>
    <v-flex class="text-center">
      <Lottie
        :options="defaultOptions"
        :height="250"
        :width="250"
        @animCreated="handleAnimation"
      />

      <h2 class="mt-4 font-weight-bold opacity-8">Loading...</h2>
    </v-flex>
  </Layout>
</template>
